var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120.28 41.156",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-905.95 -70.443)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(905.95 70.942)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(26.932 .525)",
    d: "M50.242,39.659H36.858L30.119,31.31H23.167v8.348H12.428V.242H31.205q7.781,0,12.187,4.174T47.8,15.592a16.214,16.214,0,0,1-1.818,7.731,14.005,14.005,0,0,1-5.08,5.444ZM22.819,22.278h8.427a7.823,7.823,0,0,0,5.419-2.036A6.728,6.728,0,0,0,38.93,15a6.27,6.27,0,0,0-2.236-5.045,8.14,8.14,0,0,0-5.447-1.894H22.819Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .506)",
    d: "M30.384,4.331Q26.061.236,18.422.233H0V38.915H10.537v-8.2h7.886q7.382,0,11.835-4.275A14.752,14.752,0,0,0,34.71,15.3q0-6.874-4.326-10.967m-5.8,14.628-3.449,3.449L16.731,18l-4.405,4.405L8.877,18.96l4.405-4.405L8.877,10.149,12.326,6.7l4.405,4.405L21.137,6.7l3.449,3.449L20.18,14.554Z"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-11166 -6098.1)",
    d: "m12171 6209.2a21.82 21.82 0 0 1-8.016-1.45 20.93 20.93 0 0 1-6.747-4.351 19.944 19.944 0 0 1-4.578-22.014 19.821 19.821 0 0 1 4.578-6.488 20.872 20.872 0 0 1 6.747-4.391 22.7 22.7 0 0 1 16.03 0 20.821 20.821 0 0 1 6.742 4.391 19.832 19.832 0 0 1 4.583 6.488 19.441 19.441 0 0 1-4.583 22.014 20.864 20.864 0 0 1-6.742 4.351 21.811 21.811 0 0 1-8.014 1.45zm-11.867-16.67c0 6.133 5.3 11.122 11.816 11.122s11.819-4.989 11.819-11.122h-2.882c0 4.406-4.01 7.992-8.937 7.992s-8.935-3.585-8.935-7.992zm22.048-13.429a3.41 3.41 0 1 0 3.412 3.409 3.414 3.414 0 0 0-3.41-3.409zm-20.638 0a3.41 3.41 0 1 0 3.408 3.409 3.414 3.414 0 0 0-3.406-3.409z",
    fill: "current",
    stroke: "rgba(0,0,0,0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a27f65a19cbae5017220a886d4e263ce.svg";
export { ForwardRef as ReactComponent };